// extracted by mini-css-extract-plugin
export var date = "date-module--date--tMloL";